import React, { Fragment } from 'react';
import Helmet from 'react-helmet';
import { oneOf, func, string, bool, array } from 'prop-types';

import { Link } from 'react-router-dom';
import { reduxForm, Field } from 'redux-form';
import { Segment, Button } from 'semantic-ui-react';

import Form from '~/views/common/Form';
import Heading from '~/views/common/Heading';
import Section from '~/views/common/Section';
import AuthorSelector from '~/views/common/AuthorSelector';

import General from './General';
import Settings from './Settings';
import Licenses from '~/views/common/LicensesForm';
import Address from '~/views/common/AddressForm';
import Contact from '~/views/common/ContactForm';


const OrganizationFormComponent = ({
    header,
    submit,
    linkToView = '/nh/organizations',
    isPortal = false,
    organizatioTypesByItem,
    ...rest
}) => (
    <Fragment>
        <Helmet title={`${header} Organization`} />
        <Heading
            header="Organization"
            subheader={header}
            iconName="edit"
        >
            <Button
                type="submit"
                onClick={submit}
                color="green"
                icon="save"
                content="Save"
                labelPosition="right"
            />
            <Button
                as={Link}
                to={linkToView}
                icon="cancel"
            />
        </Heading>
        <Form {...rest}>

            <Segment.Group>
                <General organizatioTypesByItem={organizatioTypesByItem} />
                <Section name="Author">
                    <Field name="author_id" component={AuthorSelector} />
                </Section>
                <Settings />
                { isPortal && <Licenses /> }
                <Contact />
                <Address />
            </Segment.Group>
        </Form>
    </Fragment>
);

OrganizationFormComponent.propTypes = {
    header: oneOf(['Edit', 'Create']).isRequired,
    submit: func.isRequired,
    linkToView: string,
    isPortal: bool,
    organizatioTypesByItem: array.isRequired,
};

const OrganizationForm = reduxForm({
    form: 'organizationForm', // A unique identifier for this form
    validate: undefined,
    asyncValidate: undefined,
})(OrganizationFormComponent);

export default OrganizationForm;
